import { useEffect, useState } from 'react'

import { issueRefundAtStatusValues } from '@/common/constants'

const useIssueRefund = (allowsIssueRefund, refundQuantity, issueRefundAtStatus, canEditIssueRefund) => {
  const [issueRefund, setIssueRefund] = useState(null)

  const canIssueRefund = allowsIssueRefund && canEditIssueRefund

  useEffect(() => {
    setIssueRefund(canIssueRefund ? issueRefundAtStatus === issueRefundAtStatusValues.accepted : false)
  }, [setIssueRefund, canIssueRefund, issueRefundAtStatus])

  return [refundQuantity <= 0 || !canIssueRefund ? false : issueRefund, setIssueRefund]
}

export default useIssueRefund
